import { useMutation } from '@tanstack/react-query';

export function useCreateProjectsAnalyticsProjectsReportsCurrentProjectsReportsExportProcessMutation() {
  return useMutation({
    mutationKey: [
      'createProjectsAnalyticsProjectsReportsCurrentProjectsReportsExportProcess',
    ],
    mutationFn: async ({ params }) => {
      const response = await axios.post(
        '/projects_analytics/projects_reports/current_projects_reports/export_processes',
        { export_process: params },
      );

      return response.data;
    },
  });
}
